define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/heading/BooleanController"
], function(declare,xml,BooleanController) {

	return declare(BooleanController, {
		toWriter: function() {
			// summary: add/remove DependsOn value
			this.m_writer.changeNode(this.m_urlNode).changeAttribute(this.heading.m_id, xml.ATTR_REFLIST, [this.widget.get("dependsOnValue")], this.newValue, !this.newValue);
		}
	});
});